// extracted by mini-css-extract-plugin
export var boxItems = "_6v-1";
export var boxItemsLg = "_6v-2";
export var button = "_6v-7";
export var buttonHoverless = "_6v-9";
export var buttonLg = "_6v-8";
export var filterGroupBox = "_6v-0";
export var icon = "_6v-3";
export var iconSecondary = "_6v-6";
export var iconWrapper = "_6v-4";
export var iconWrapperLg = "_6v-5";
export var truncatedLabel = "_6v-a";